import React from 'react'
import { Path, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'

export default function IconPdOutlined({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M6 12H8C8.53043 12 9.03914 11.7893 9.41421 11.4142C9.78929 11.0391 10 10.5304 10 10C10 9.46957 9.78929 8.96086 9.41421 8.58579C9.03914 8.21071 8.53043 8 8 8H6V16"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 8V16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V10C18 9.46957 17.7893 8.96086 17.4142 8.58579C17.0391 8.21071 16.5304 8 16 8H14Z"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 5.77778C2 5.30628 2.23413 4.8541 2.65087 4.5207C3.06762 4.1873 3.63285 4 4.22222 4H19.7778C20.3671 4 20.9324 4.1873 21.3491 4.5207C21.7659 4.8541 22 5.30628 22 5.77778V18.2222C22 18.6937 21.7659 19.1459 21.3491 19.4793C20.9324 19.8127 20.3671 20 19.7778 20H4.22222C3.63285 20 3.06762 19.8127 2.65087 19.4793C2.23413 19.1459 2 18.6937 2 18.2222V5.77778Z"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
